import { Checkbox } from '../ui/checkbox';

const REPORTS = [
  ['jobs', 'Job reports — PDF and Word'],
  ['field_tickets', 'Daily Field Ticket PDFs'],
  ['compliance', 'Compliance PDFs'],
  ['completed_forms', 'Completed form PDFs'],
];
export const DEFAULT_REPORT_TYPES = REPORTS.map(([key]) => key);

export const LetterheadReportTypes = ({ value, onChange, disabled }) => <fieldset className="space-y-3" data-testid="letterhead-report-types">
  <legend className="text-sm font-medium mb-2" data-testid="letterhead-report-types-label">Automatically apply to</legend>
  {REPORTS.map(([key, label]) => <label key={key} htmlFor={`letterhead-report-${key.replaceAll('_', '-')}`} className="flex items-center gap-3 text-sm cursor-pointer" data-testid={`letterhead-report-label-${key.replaceAll('_', '-')}`}>
    <Checkbox id={`letterhead-report-${key.replaceAll('_', '-')}`} data-testid={`letterhead-report-${key.replaceAll('_', '-')}`} checked={value.includes(key)} disabled={disabled} className="shrink-0 border-slate-500 data-[state=checked]:bg-slate-900 data-[state=checked]:text-white" onCheckedChange={(checked) => onChange(checked === true ? [...value, key] : value.filter((item) => item !== key))} />
    <span>{label}</span>
  </label>)}
</fieldset>;